import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/components/utils/utils";

interface TravelRequestCardSkeletonProps {
  className?: string;
}

/** Segnaposto di TravelRequestCard mentre arriva la pagina: stesse misure, nessun salto. */
export const TravelRequestCardSkeleton = ({ className }: TravelRequestCardSkeletonProps) => (
  <Card aria-hidden="true" className={cn("border border-gray-200 rounded-2xl", className)}>
    <CardContent className="p-3 h-full flex flex-col">
      {/* Data di creazione e badge */}
      <div className="flex justify-between items-center mb-4">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>

      {/* Destinazione */}
      <Skeleton className="h-5 w-2/3 mb-4" />

      {/* Date, ospiti, budget, provenienza */}
      <div className="flex-1 py-3">
        <div className="grid grid-cols-2 gap-4">
          <Skeleton className="h-4 w-3/4 col-span-2" />
          <div className="space-y-3">
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-3/4" />
          </div>
          <div className="space-y-3">
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        </div>
      </div>

      {/* Cliente e pulsante */}
      <div className="mt-4 space-y-3">
        <div className="flex items-center gap-2">
          <Skeleton className="h-7 w-7 rounded-full" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        {/* Area grande: grigio piu' tenue, cosi' non si nota piu' delle barre di testo */}
        <Skeleton className="h-12 w-full rounded-xl bg-gray-50" />
      </div>
    </CardContent>
  </Card>
);
